import { useState, useSyncExternalStore } from 'react';

import { createSettledTaskClaims, type SettledTaskClaimsStore } from '~/utils/taskUtils/settledTaskClaims';

export type SettledTaskClaims = Omit<SettledTaskClaimsStore, 'subscribe' | 'getVersion'>;

/**
 * The remote tasks this instance has settled, and a re-render whenever that set moves — the caller
 * decides whether it still has anything to poll for by reading it, and a claim is not always
 * followed by a redux dispatch that would re-render on its own.
 */
export const useSettledTaskClaims = (): SettledTaskClaims => {
  const [settledTaskClaims] = useState(createSettledTaskClaims);

  useSyncExternalStore(settledTaskClaims.subscribe, settledTaskClaims.getVersion, settledTaskClaims.getVersion);

  return settledTaskClaims;
};
